'use strict';

module.exports = require('./node/');



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/platform/index.js
// module id = ira4
// module chunks = 142